import React, { useCallback } from "react";
import { TextField } from "@mui/material";
import debounce from "lodash/debounce";
import { Icon } from "../index";
import styles from "./Search.module.css";

const Search = ({ onSearch, placeholder }) => {
  const debouncedSearch = useCallback(
    debounce((value) => {
      onSearch(value);
    }, 400),
    [onSearch],
  );

  const handleChange = (event) => {
    const value = event.target.value;
    debouncedSearch(value);
  };

  return (
    <div className={styles.searchContainer}>
      <TextField
        placeholder={placeholder}
        variant="outlined"
        size="small"
        onChange={handleChange}
        InputProps={{
          endAdornment: <Icon icon="search" />,
        }}
      />
    </div>
  );
};

export default Search;
